var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Checkout',{attrs:{"hasCreditCardCheckout":_vm.hasCCCheckout,"query":_vm.query},on:{"taxesDone":_vm.trackCheckoutStarted}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }